import React from "react";

import svg from "../../assets/images/icons/show_error_branch.svg";

export const ErrorBranchIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Error Branch"}
    />
);
